<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h1" id="t002">PART 1:<br/><span class="txbf"><span class="txit">The Coming of the Plague</span></span></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?5c94a762